export interface IPlannerState {
  tourVisibility: {[key: string] : boolean}
}

//initial state
export default {
  tourVisibility: {}
} as IPlannerState
